<div class="nb-input-container" :class="{'hide-in-mobile' : isHidden && isMobile}">
  <div v-if="!isHidden" class="nb-input" :class="{ focused: isFocused, filled: hasValue, error: error }">
    <input
      :id="id"
      :type="type"
      @input="onInput"
      :value="modelValue"
      :disabled="disabled"
      :autocomplete="autocomplete"
      :name="name"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />

    <label v-if="label" :for="id">
      {{ label }}
    </label>
  </div>

  <div v-if="error" class="error-message">
    {{ error }}
  </div>
</div>
